import HttpService from './http.service';

class CompanyService {
  getCompanies(params) {
    return HttpService.get('companies', {
      params,
    })
      .then((res) => res.data);
  }

  getCompanyTypes() {
    return HttpService.get('companies/types')
      .then((res) => res.data);
  }

  suggestCompanies(params) {
    return HttpService.get('companies/suggestions', { params })
      .then((res) => res.data);
  }

  attachUser(companyId, userId) {
    return HttpService.put(`companies/${companyId}/users/${userId}`)
      .then((res) => res.data);
  }

  getCompany(id) {
    return HttpService.get(`companies/${id}`)
      .then((res) => res.data);
  }

  createCompany(company) {
    return HttpService.post('companies', company)
      .then((res) => res.data);
  }

  updateCompany(company) {
    return HttpService.patch(`companies/${company.id}`, company)
      .then((res) => res.data);
  }

  deleteCompany(company) {
    return HttpService.delete(`companies/${company.id}`)
      .then((res) => res.data);
  }
}

export default new CompanyService();
